<template style="padding-top: 0px">
    <div class="jump-usercent" id="bodyHeight">
        <div id="contentHeight">
            <div class="jump-header">

            </div>
            <van-row class="jump-usercent-header" type="flex">
                <van-col span="6">
                    <img src="../assets/avatar.png">
                </van-col>
                <van-col span="12" class="jump-usercent-header-title">
                    <h5>{{username}}</h5>
                    <p style="font-size: 12px;">手机号:{{mobile}}</p>
                </van-col>
                <van-col span="6" class="jump-usercent-header-set">
                    <a href="#/user/safe"><span class="iconfont icon-shezhi"></span></a>
                </van-col>
            </van-row>
            <van-row v-if="isMember">
                <van-row class="jump-usercent-order">
                    <van-col span="12" class="text-left">
                        <a href="#/user/order?type=100">
                            <van-icon name="orders-o"/>
                            我的订单</a>
                    </van-col>
                    <van-col span="12" class="text-right">
                        <a href="#/user/order?type=100">查看全部订单</a>
                    </van-col>
                </van-row>
                <van-row class="jump-usercent-orderste">
                    <van-col span="4">
                        <a href="#/user/order?type=10">
                            <i class="iconfont icon-shouhuoziliao"></i>
                            <h5>待付款</h5>
                            <span class="jump-usercent-orderste-dot">{{orderTypeNum.waitPay>99?'99+':orderTypeNum.waitPay}}</span>
                        </a>
                    </van-col>
                    <van-col span="4">
                        <a href="#/user/order?type=20">
                            <i class="iconfont icon-daifahuo"></i>
                            <h5>待发货</h5>
                            <span class="jump-usercent-orderste-dot">{{orderTypeNum.paied>99?'99+':orderTypeNum.paied}}</span>
                        </a>
                    </van-col>
                    <van-col span="4">
                        <a href="#/user/order?type=30">
                            <i class="iconfont icon-daishouhuo"></i>
                            <h5>已发货</h5>
                            <span class="jump-usercent-orderste-dot">{{orderTypeNum.sended>99?'99+':orderTypeNum.sended}}</span>
                        </a>
                    </van-col>
                    <van-col span="4">
                        <a href="#/user/order?type=40">
                            <i class="iconfont icon-shouhuoziliao"></i>
                            <h5>已收货</h5>
                        </a>
                    </van-col>
                    <van-col span="4">
                        <a href="#/user/order?type=50">
                            <i class="iconfont icon-yiwancheng"></i>
                            <h5>已完成</h5>
                        </a>
                    </van-col>
                    <van-col span="4">
                        <a href="#/user/order?type=0">
                            <i class="iconfont icon-lajitong"></i>
                            <h5>已取消</h5>
                            <span class="jump-usercent-orderste-dot"></span>
                        </a>
                    </van-col>
                </van-row>
            </van-row>
            <van-row v-else>
                <van-row class="jump-usercent-orderste">
                    <van-col span="8">
                        <a @click="approvallist">
                            <i class="iconfont icon-dingdan- red"></i>
                            <h5>审批列表</h5>
                            <span class="jump-usercent-orderste-dot2">{{orderTypeNum.appCount>99?'99+':orderTypeNum.appCount}}</span>
                        </a>
                    </van-col>

                    <van-col span="8">
                        <a href="#/staff/delivery/list">
                            <i class="iconfont icon-gongsixinxiguanli orange"></i>
                            <h5>出库单管理</h5>
                            <span class="jump-usercent-orderste-dot"></span>
                        </a>
                    </van-col>

                    <van-col span="8" v-if="isShowIntegralBt=='true'">
                        <a href="#/staff/integral/order">
                            <i class="iconfont icon-dingdan- purple"></i>
                            <h5>积分订单审核</h5>
                            <span class="jump-usercent-orderste-dot2">{{orderTypeNum.IntegralOrderAppCount>99?'99+':orderTypeNum.IntegralOrderAppCount}}</span>
                        </a>
                    </van-col>

                </van-row>
            </van-row>
            <div class="jump-usercent-fun">
                <van-row>
                    <van-col span="6" v-if="isSignMember || isMember || userRole.indexOf('BM')!=-1 ">
                        <a href="#/user/order?type=100">
                            <i class="iconfont icon-daifahuo red"></i>
                            <h5>我的订单</h5>
                        </a>
                    </van-col>
                    <van-col span="6" v-if="isMember">
                        <a href="#/user/collect">
                            <i class="iconfont icon-shoucang red"></i>
                            <h5>我的收藏</h5>
                        </a>
                    </van-col>
                    <van-col span="6" v-if="isMember">
                        <a href="#/user/comment">
                            <i class="iconfont icon-pinglun blue"></i>
                            <h5>我的评论</h5>
                        </a>
                    </van-col>
                    <van-col span="6" v-if="integralStore">
                        <a href="#/user/integral">
                            <i class="iconfont icon-jifen yellow"></i>
                            <h5>我的积分</h5>
                        </a>
                    </van-col>

                    <van-col span="6" v-if="integralStore">
                        <!-- <a href="#/user/order/intergral">
                            <i class="iconfont icon-duizhang purple"></i>
                            <h5>积分统计</h5>
                        </a> -->
                        <a @click="goIntergral">
                            <i class="iconfont icon-duizhang purple"></i>
                            <h5>积分统计</h5>
                        </a>
                    </van-col>

                    <van-col span="6" v-if="integralStore">
                        <a href="#/user/integral/order">
                            <i class="iconfont icon-dingdan- purple"></i>
                            <h5>积分订单</h5>
                        </a>
                    </van-col>
                    <van-col span="6" v-if="isMember">
                        <a href="#/user/address">
                            <i class="iconfont icon-shouhuodizhi blue"></i>
                            <h5>收货地址</h5>
                        </a>
                    </van-col>
                    <van-col span="6">
                        <a href="#/user/info">
                            <i class="iconfont icon-gerenziliao pink"></i>
                            <h5>个人资料</h5>
                        </a>
                    </van-col>
                    <van-col span="6">
                        <a @click="bindWX" v-if="wxOpenid == ''">
                            <i class="iconfont icon-weixin-copy green"></i>
                            <h5>微信绑定</h5>
                        </a>
                        <a @click="unbindWX" v-if="wxOpenid != ''">
                            <i class="iconfont icon-weixin-copy green"></i>
                            <h5>微信解绑</h5>
                        </a>
                    </van-col>
                    <van-col span="6" v-if="isMember">
                        <a href="#/user/history">
                            <i class="iconfont icon-lishijilu orange"></i>
                            <h5>浏览历史</h5>
                        </a>
                    </van-col>
                    <!--</van-row>
                    <van-row>-->
                    <van-col span="6" v-if="isMember">
                        <a href="#/user/cons">
                            <i class="iconfont icon-yijin12-zaixianzixun yellow"></i>
                            <h5>站内咨询</h5>
                        </a>
                    </van-col>
                     <van-col span="6" v-if="userRole=='SSM'">
                        <a href="#/user/cons?type=1">
                            <i class="iconfont icon-yijin12-zaixianzixun yellow"></i>
                            <h5>技术咨询</h5>
                        </a>
                    </van-col>
                    <van-col span="6">
                        <a href="#/message/center">
                            <i class="iconfont icon-notice red"></i>
                            <h5>站内消息</h5>
                        </a>
                    </van-col>
                    <van-col span="6" v-if="isSignMember">
                        <a href="#/user/bill">
                            <i class="iconfont icon-duizhang purple"></i>
                            <h5>月度对账</h5>
                        </a>
                    </van-col>
                    <!-- <van-col span="6" v-if="userRole.indexOf('BM')!=-1">
                        <a href="#/user/replaceOrder">
                            <i class="iconfont icon-dingdan- red"></i>
                            <h5>代下单</h5>
                        </a>
                    </van-col> -->
                    <!--  <van-col span="6" v-if="isMember">
                          <a href="#/user/bindAccount">
                              <i class="iconfont icon-dingdan- red"></i>
                              <h5>绑定账户</h5>
                          </a>
                      </van-col>-->

                    <van-col span="6" v-if="!isMember">
                        <a @click="approvallist">
                            <i class="iconfont icon-dingdan- red"></i>
                            <h5>审批列表</h5>
                        </a>
                    </van-col>
                    <van-col span="6" v-if="!isMember">
                        <a href="#/staff/delivery/list">
                            <i class="iconfont icon-gongsixinxiguanli orange"></i>
                            <h5>出库单管理</h5>
                        </a>
                    </van-col>
                    <van-col span="6" v-if="isShowIntegralBt=='true'">
                        <a href="#/staff/integral/order">
                            <i class="iconfont icon-dingdan- purple"></i>
                            <h5>积分订单审核</h5>
                        </a>
                    </van-col>
                    <!-- 卖家看到的 -->
                    <van-col span="6" v-if="userRole.indexOf('BUYER')!=-1">
                        <a href="#/user/task">
                            <i class="iconfont icon-dingdan- purple"></i>
                            <h5>消费任务</h5>
                        </a>
                    </van-col>
                    <!-- 业务员看到的 -->
                      <van-col span="6" v-if="userRole.indexOf('BM')!=-1">
                        <a href="#/user/records">
                            <i class="iconfont icon-dingdan- purple"></i>
                            <h5>消费任务</h5>
                        </a>
                    </van-col>
                  
                     <van-col span="6">
                        <a @click="isDown=true">
                             <span ><img class="load" src="../assets/img/load.png" /></span>
                            <h5 style="color:#666">推荐下载</h5>
                        </a>
                    </van-col>
                </van-row>
            </div>
        </div>
        <div :style="{'text-align':'center','color': '#d8d8d8','position': 'fixed','width': '100%','bottom':versionHeight}"
             id="appVersion" v-if="isMobile">
            当前版本号{{appVersion}}
        </div>
        <van-tabbar v-model="tabActive" active-color="#3c6eeb" id="bottomHeight">
            <van-tabbar-item url="#/home">
                <i slot="icon" class="iconfont icon-shouye"></i>
                首页
            </van-tabbar-item>
            <van-tabbar-item icon="label-o" url="#/cate">
                <i slot="icon" class="iconfont icon-icon-"></i>
                分类
            </van-tabbar-item>
            <van-tabbar-item icon="label-o" url="#/message/center">
                <i slot="icon" class="iconfont icon-ico_msg"></i>
                消息
            </van-tabbar-item>
            <van-tabbar-item icon="cart-o" url="#/cart">
                <i slot="icon" class="iconfont icon-gouwuche1"></i>
                购物车
            </van-tabbar-item>
            <van-tabbar-item icon="contact" url="#/usercent">
                <i slot="icon" class="iconfont icon-ziyuan2"></i>
                我的
            </van-tabbar-item>
        </van-tabbar>
        <!-- 推荐下载弹出框 -->
        <van-popup v-model="isDown">
            <img src="../assets/img/download.png"/>
        </van-popup>
    </div>
</template>
<script>
    import {Row, Col, Tabbar, TabbarItem, Dialog,Popup} from "vant";

    export default {
        name: "userCenter",
        components: {
            [Row.name]: Row,
            [Col.name]: Col,
            [Tabbar.name]: Tabbar,
            [TabbarItem.name]: TabbarItem,
            [Dialog.name]: Dialog,
             [Popup.name]: Popup
        },
        data() {
            return {
                isShowIntegralBt: localStorage.getItem("isShowIntegralBt"),
                user_type: localStorage.getItem("user_type"),
                userRole: localStorage.getItem("userRole") ? localStorage.getItem("userRole") : "", //BUYER
                tabActive: 4,
                username: localStorage.getItem("name"),
                mobile: localStorage.getItem("mobile"),
                orderTypeNum: {},
                wxOpenid: '',//微信id
                integralStore: eval(localStorage.getItem('integralStore')),
                isMember: false,
                isSignMember: false,
                appVersion: 0,
                isMobile: true,
                versionHeight: '',
                isDown:false,
            };
        },
        // beforeCreate:function(){
        //     let that = this;
        //     if (!that.$api.isLogin()) {
        //         location.href = '#/login'
        //         return;
        //     }
        // },
        beforeDestroy() {

            document.querySelector('.wrapper').className = 'wrapper';
        },
        mounted: function () {
            document.querySelector('.wrapper').className = 'wrapper no-header';
            let that = this;
            //判断是否是会员、是否是签约会员
            that.isMember = this.userRole == 'BUYER';
            that.isSignMember = that.isMember && this.user_type == 2;

            that.getUserInfo();
            localStorage.setItem("order_type", '')
             //版本号
            if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
                that.appVersion = that.$api.iosVersion
            }
            if (navigator.userAgent.match(/android/i)) {
                that.appVersion = that.$api.andoridVersion
            }
            that.isMobile = this.$checkMobile.isMobile;
            that.versionHeight = document.getElementById("bottomHeight").scrollHeight + "px"
        },
        methods: {
            approvallist() {//审批列表
                localStorage.setItem("scrollLenth", 0);
                localStorage.setItem("scrollPage", 1);
                location.href = "#/staff/approval"
            },
            
            goIntergral() {//跳转积分统计
                if (this.userRole.indexOf('BUYER') > -1) {
                    location.href = "#/user/order/intergral"
                } else if (this.userRole.indexOf('BM') > -1) {
                    location.href = "#/user/order/intergral2?role=BM"
                }else if(this.userRole.indexOf('ECENGINEER') > -1){
                    location.href = "#/user/order/intergral2?role=ECENGINEER"
                }
            },
            getUserInfo() {
                let that = this
                that.$api.get(
                    that.jumuc.userCenter.getUserInfo, null,
                    successRes => {
                        that.orderTypeNum = successRes.data;
                        that.wxOpenid = successRes.data.user.wxOpenid || '';
                        //this.showMaskImg=successRes.data.showMaskImg;
                    }
                )
            },
            unbindWX() {
                let that = this;
                Dialog.confirm({
                    title: '提示',
                    message: '是否确认解绑微信'
                }).then(() => {
                    that.$api.post(that.jumuc.wx.delWx, {}, successRes => {
                        that.$toast(successRes.msg)
                        if (successRes.success) {
                            that.wxOpenid = '';
                            that.$toast("解绑成功!")
                        } else {
                            that.$toast("解绑失败!")
                        }
                    })
                }).catch(() => {
                });
            },
            bindWX() {
                let that = this;
                if (that.wxOpenid) {
                    that.$toast("您已绑定微信,无需重复绑定");
                    return;
                }
                Dialog.confirm({
                    title: '提示',
                    message: '是否确认绑定微信'
                }).then(() => {
                    var scope = "snsapi_userinfo",
                        state = "_" + (+new Date());
                    Wechat.auth(scope, state, function (response) {
                        var url = "https://api.weixin.qq.com/sns/oauth2/access_token?appid=" + that.jumuc.wx.appId + "&secret=" + that.jumuc.wx.appSecret + "&code=" + response.code + "&grant_type=authorization_code";
                        that.$api.get(url, {},
                            successRes => {
                                var openid = successRes.openid;
                                that.$api.post(that.jumuc.wx.saveWx, {"wxOpenId": openid}, successRes => {
                                    if (successRes.success) {
                                        that.wxOpenid = openid;
                                        that.$toast("绑定成功!")
                                    } else {
                                        that.$toast("绑定失败!")
                                    }
                                })
                            });
                    }, function (reason) {
                        that.$toast("Failed: " + reason);
                    });
                }).catch(() => {
                });

            },
            bindUser() {
                //账号绑定
            }
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3C6EEB;
    body {
        background-color: #f7f7f7;
    }

    .jump-usercent {
        padding-bottom: 50px;
        &-header {
            padding: 40px 10px 15px;
            background-color: #3C6EEB;
            color: #f1f1f1;
            &-title {
                padding-left: 10px;
            }
            h5 {
                margin-bottom: 10px;
            }
            img {
                width: 100%;
                border-radius: 50%;
            }
            &-set {
                text-align: right;
                font-size: 24px;
                padding-right: 10px;
                span {
                    font-size: 26px;
                }
            }
            div {
                align-self: flex-end;
            }
            a {
                color: #f1f1f1
            }
        }
        &-order {
            padding: 25px 20px;
            font-size: 18px;
            vertical-align: middle;
            color: #000;
            border-bottom: 1px solid #eee;
            background-color: #fff;
            .van-icon {
                margin-right: 2px;
                vertical-align: -2px;
                color: @bule-thame
            }
        }
        &-orderste {
            padding: 15px 10px;
            background-color: #fff;
            margin-bottom: 20px;
            h5 {
                font-size: 14px;
                color: #000;
            }
            a {
                position: relative;
                display: block;
                text-align: center;
            }
            a i {
                font-size: 24px;
                color: @bule-thame;
            }
            &-dot {
                position: absolute;
                top: 2px;
                right: 8px;
                font-size: 12px;
                width: 18px;
                background-color: red;
                color: #fff;
                border-radius: 50%;
            }
        }
        &-fun {
            background-color: #fff;
            > div {
                text-align: center;
                border-bottom: 1px solid #eee;
                > div {
                    padding: 8px 0;
                }
                i {
                    font-size: 24px;
                }
                h5 {
                    font-size: 14px;
                }
                &:last-child {
                    border: none
                }
            }
        }
    }

    .jump-usercent-orderste-dot2 {
        position: absolute;
        top: -5px;
        right: 33px;
        font-size: 12px;
        width: 18px;
        background-color: red;
        color: #fff;
        border-radius: 50%;
    }
    .mask{
        width: 30px;margin-bottom: 5px;
    }
    .load{
        width:25px;
        height:25px;
        margin-bottom:10px;
    }
    /deep/ .van-popup {
        width:300px;
        height:300px;
        img{
            width:100%;
            height:100%;
        }
    }
</style>

